"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoizify = void 0;
const task_exec_1 = require("../common/tesk-exec/task-exec");
function memoizify(originalMethod, input) {
    const defaultConfig = {
        cache: new Map(),
    };
    const runner = new task_exec_1.TaskExec();
    let resolvedConfig = Object.assign({}, defaultConfig);
    if (typeof input === 'number') {
        resolvedConfig.expirationTimeMs = input;
    }
    else {
        resolvedConfig = Object.assign(Object.assign({}, resolvedConfig), input);
    }
    return function (...args) {
        const keyResolver = typeof resolvedConfig.keyResolver === 'string'
            ? this[resolvedConfig.keyResolver].bind(this)
            : resolvedConfig.keyResolver;
        const key = keyResolver
            ? keyResolver(...args)
            : JSON.stringify(args);
        if (!resolvedConfig.cache.has(key)) {
            const response = originalMethod.apply(this, args);
            if (resolvedConfig.expirationTimeMs !== undefined) {
                runner.exec(() => {
                    resolvedConfig.cache.delete(key);
                }, resolvedConfig.expirationTimeMs);
            }
            resolvedConfig.cache.set(key, response);
        }
        return resolvedConfig.cache.get(key);
    };
}
exports.memoizify = memoizify;
